import React from 'react';
import PhoneNumberType from 'src/models/PhoneNumberType';

import { FormRow, SelectInput, TextInput } from '../reactHookForm';
import { useFormContext, useFieldArray } from 'react-hook-form';
import Button from '../redesign/FormButton';

interface IPhoneNumberProps {
    phoneTypes?: PhoneNumberType[];
}

const PhoneNumberData = (props: IPhoneNumberProps) => {
    const { register, control, watch } = useFormContext();

    const { fields, append, remove } = useFieldArray({
        name: `phoNumberChanges.phoneNumberAdds`,
        control: control,
    });

    const addNewPhone = () => {
        append({
            isPrimary: false,
            number: 0,
            typeId: 0,
        });
    };

    return (
        <>
            {fields?.map((field, index) => {
                let watchTypeChange: number = watch(`phoneNumberChanges.phoneNumberAdds[${index}].typeId`, 0);

                return (
                    <FormRow
                        layout={!!watchTypeChange && watchTypeChange === 2 ? [1, 2, 1, 1, 1] : [1, 2, 0, 1, 1]}
                        key={field.id}
                        style={{ alignItems: 'center' }}
                    >
                        <div>
                            <input
                                style={{ marginRight: '1rem' }}
                                type="checkbox"
                                name={`phoneNumberChanges.phoneNumberAdds[${index}].isPrimary`}
                                ref={register}
                            />
                            <label htmlFor="">Primary</label>
                        </div>
                        <TextInput label="Phone Number" name={`phoneNumberChanges.phoneNumberAdds[${index}].number`} isRequired={true} />
                        {!!watchTypeChange && watchTypeChange === 2 ? (
                            <TextInput label="Ext." name={`phoneNumberChanges.phoneNumberAdds[${index}].extension`} />
                        ) : (
                            <></>
                        )}
                        <SelectInput
                            label="Phone Number Type"
                            name={`phoneNumberChanges.phoneNumberAdds[${index}].typeId`}
                            options={
                                !!props?.phoneTypes &&
                                props.phoneTypes.map((pt) => {
                                    return { id: pt.id, name: `${pt.type}` };
                                })
                            }
                            isCreatable={true}
                        />
                        <Button text="Delete" onClick={() => remove(index)} size="medium" />
                    </FormRow>
                );
            })}
            <div>
                <Button text="Add Number" onClick={addNewPhone} style={{ marginTop: '1rem' }} />
            </div>
        </>
    );
};

export default PhoneNumberData;



// WEBPACK FOOTER //
// ./src/components/controls/forms/composite/PhoneNumberData.tsx